import type { TechnicalProduct } from './technical-catalog'

// Manufacturer facts for the exact mount/generation shown, never marketplace ads.
export const technicalLensExtra: TechnicalProduct[] = [
  {
    "id": "samyang-af-24-18-fe",
    "name": "Samyang AF 24mm F1.8 FE",
    "kind": "lenses",
    "checkedAt": "2026-10-16",
    "sourceUrl": "https://samyangus.com/collections/compact-auto-focus/products/24mm-f1-8-af-compact-full-frame-wide-angle-sony-e",
    "mount": "sony_e",
    "facts": {
      "Attacco": "Sony E",
      "Copertura": "Full frame",
      "Focale": "24 mm",
      "Apertura massima": "f/1,8",
      "Messa a fuoco": "Autofocus STM; controllo manuale",
      "Distanza minima di messa a fuoco": "0,19 m",
      "Diametro filtri": "58 mm",
      "Lamelle diaframma": "9",
      "Peso dichiarato": "230 g"
    },
    "numeric": {
      "focalMm": 24,
      "fNumber": 1.8,
      "weightGrams": 230
    },
    "note": "Scheda della versione Sony E. Verifica il modello esatto e il firmware sulla tua fotocamera; i dati del produttore non descrivono lo stato dell’esemplare usato."
  },
  {
    "id": "samyang-af-35-18-fe",
    "name": "Samyang AF 35mm F1.8 FE",
    "kind": "lenses",
    "checkedAt": "2026-10-16",
    "sourceUrl": "https://samyangus.com/collections/compact-auto-focus/products/35mm-f1-8-af-compact-full-frame-wide-angle-sony-e",
    "mount": "sony_e",
    "facts": {
      "Attacco": "Sony E",
      "Copertura": "Full frame",
      "Focale": "35 mm",
      "Apertura massima": "f/1,8",
      "Messa a fuoco": "Autofocus STM; controllo manuale",
      "Distanza minima di messa a fuoco": "0,29 m",
      "Diametro filtri": "58 mm",
      "Lamelle diaframma": "9",
      "Peso senza tappi e paraluce": "210 g"
    },
    "numeric": {
      "focalMm": 35,
      "fNumber": 1.8,
      "weightGrams": 210
    },
    "note": "Versione AF 35mm F1.8 FE, distinta dalla successiva P FE e dai modelli f/1,4. Verifica firmware e funzioni supportate dalla fotocamera."
  },
  {
    "id": "samyang-af-45-18-fe",
    "name": "Samyang AF 45mm F1.8 FE",
    "kind": "lenses",
    "checkedAt": "2026-10-16",
    "sourceUrl": "https://samyangus.com/collections/compact-auto-focus/products/45mm-f1-8-af-compact-full-frame-sony-e",
    "mount": "sony_e",
    "facts": {
      "Attacco": "Sony E",
      "Copertura": "Full frame",
      "Focale": "45 mm",
      "Apertura massima": "f/1,8",
      "Messa a fuoco": "Autofocus STM; controllo manuale",
      "Distanza minima di messa a fuoco": "0,45 m",
      "Diametro filtri": "49 mm",
      "Lamelle diaframma": "9",
      "Peso dichiarato": "162 g"
    },
    "numeric": {
      "focalMm": 45,
      "fNumber": 1.8,
      "weightGrams": 162
    },
    "note": "Scheda della versione Sony E. Campo inquadrato e distanza di lavoro dipendono anche dal formato del sensore."
  },
  {
    "id": "samyang-af-75-18-fe",
    "name": "Samyang AF 75mm F1.8 FE",
    "kind": "lenses",
    "checkedAt": "2026-10-16",
    "sourceUrl": "https://samyangus.com/collections/compact-auto-focus/products/75mm-f1-4-af-compact-full-frame-sony-e",
    "mount": "sony_e",
    "facts": {
      "Attacco": "Sony E",
      "Copertura": "Full frame",
      "Focale": "75 mm",
      "Apertura massima": "f/1,8",
      "Messa a fuoco": "Autofocus STM; controllo manuale",
      "Distanza minima di messa a fuoco": "0,69 m",
      "Diametro filtri": "58 mm",
      "Lamelle diaframma": "9",
      "Peso dichiarato": "230 g"
    },
    "numeric": {
      "focalMm": 75,
      "fNumber": 1.8,
      "weightGrams": 230
    },
    "note": "Versione Sony E full frame, non la versione Fujifilm X. Il titolo e la tabella della fonte identificano il modello f/1,8."
  },
  {
    "id": "samyang-af-85-14-fe-ii",
    "name": "Samyang AF 85mm F1.4 FE II",
    "kind": "lenses",
    "checkedAt": "2026-10-16",
    "sourceUrl": "https://samyangus.com/collections/samyang-lenses/products/85mm-f1-4-af-series-ii-full-frame-telephoto-sony-e",
    "mount": "sony_e",
    "facts": {
      "Attacco": "Sony E",
      "Copertura": "Full frame",
      "Focale": "85 mm",
      "Apertura massima": "f/1,4",
      "Messa a fuoco": "Autofocus STM lineare; controllo manuale",
      "Distanza minima di messa a fuoco": "0,85 m",
      "Diametro filtri": "72 mm",
      "Lamelle diaframma": "9",
      "Peso dichiarato": "509 g"
    },
    "numeric": {
      "focalMm": 85,
      "fNumber": 1.4,
      "weightGrams": 509
    },
    "note": "Scheda della seconda generazione FE II: non attribuire peso e funzioni alla precedente versione AF 85mm F1.4 FE o alle varianti per reflex."
  },
  {
    "id": "samyang-af-135-18-fe",
    "name": "Samyang AF 135mm F1.8 FE",
    "kind": "lenses",
    "checkedAt": "2026-10-16",
    "sourceUrl": "https://samyangus.com/collections/auto-focus/products/135mm-f1-8-af-full-frame-telephoto-sony-e",
    "mount": "sony_e",
    "facts": {
      "Attacco": "Sony E",
      "Copertura": "Full frame",
      "Focale": "135 mm",
      "Apertura massima": "f/1,8",
      "Messa a fuoco": "Autofocus STM lineare; controllo manuale",
      "Distanza minima di messa a fuoco": "0,69 m",
      "Diametro filtri": "82 mm",
      "Lamelle diaframma": "11",
      "Peso senza tappi e paraluce": "772 g"
    },
    "numeric": {
      "focalMm": 135,
      "fNumber": 1.8,
      "weightGrams": 772
    },
    "note": "Versione autofocus Sony E, diversa dal 135mm f/2 ED UMC manuale. Stabilità del supporto, distanza di lavoro e stato dell’esemplare restano da valutare."
  },
  {
    "id": "samyang-mf-14-28-umc-canon-ef",
    "name": "Samyang 14mm F2.8 ED AS IF UMC (Canon EF)",
    "kind": "lenses",
    "checkedAt": "2026-10-16",
    "sourceUrl": "https://samyangus.com/collections/manual-focus/products/14mm-f2-8-full-frame-ultra-wide-angle",
    "mount": "canon_ef",
    "facts": {
      "Attacco": "Canon EF; versione SY14M-C",
      "Copertura": "Full frame",
      "Focale": "14 mm",
      "Apertura massima": "f/2,8",
      "Messa a fuoco": "Manuale",
      "Distanza minima di messa a fuoco": "0,28 m",
      "Filtri frontali a vite": "Nessun attacco standard indicato dal produttore",
      "Lamelle diaframma": "6",
      "Peso dichiarato per Canon EF": "550 g"
    },
    "numeric": {
      "focalMm": 14,
      "fNumber": 2.8,
      "weightGrams": 550
    },
    "note": "Scheda della versione manuale Canon EF originale SY14M-C, non AF, RF né MK2. Attacchi differenti hanno pesi e dimensioni differenti; l’eventuale uso con adattatore va verificato separatamente."
  },
  {
    "id": "samyang-mf-135-2-umc-canon-ef",
    "name": "Samyang 135mm F2.0 ED UMC (Canon EF)",
    "kind": "lenses",
    "checkedAt": "2026-10-16",
    "sourceUrl": "https://samyangus.com/collections/manual-focus/products/135mm-f2-0-full-frame-telephoto",
    "mount": "canon_ef",
    "facts": {
      "Attacco": "Canon EF; versione SY135M-C",
      "Copertura": "Full frame",
      "Focale": "135 mm",
      "Apertura massima": "f/2",
      "Messa a fuoco": "Manuale",
      "Distanza minima di messa a fuoco": "0,8 m",
      "Diametro filtri": "77 mm",
      "Lamelle diaframma": "9",
      "Peso dichiarato per Canon EF": "830 g"
    },
    "numeric": {
      "focalMm": 135,
      "fNumber": 2,
      "weightGrams": 830
    },
    "note": "Scheda della versione manuale Canon EF. La stessa famiglia è proposta con altri attacchi, ma i pesi non sono intercambiabili; non è il modello AF 135mm f/1,8 FE."
  }
]
